import config from "../../config";
import { apiFetch, createMultiConsumerGet } from "./apiFetch";


const getAccountId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.accountId;
};

const parseErrorMessage = async (response, fallback) => {
    try {
        const body = await response.json();
        return body?.error || body?.message || fallback;
    } catch {
        return fallback;
    }
};

const buildUrl = (path, params = {}) => {
    const filtered = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ""
        )
    );
    const query = new URLSearchParams({
        account_id: getAccountId(),
        ...filtered,
    });
    return `${config.apiUrl}/${path}?${query}`;
};

const sharedGet = createMultiConsumerGet(async (url, options) => {
    const response = await apiFetch(url, options);
    if (!response.ok) throw new Error(await parseErrorMessage(response, `HTTP ${response.status}`));
    return response.json();
});
const get = (path, params = {}, options = {}) => {
    const url = buildUrl(path, params);
    return sharedGet(url, options);
};

export const isFinalApprovalDecision = (result) =>
    result?.fully_approved !== false &&
    result?.fullyApproved !== false &&
    result?.next_level == null &&
    result?.nextLevel == null;

export const getApprovalCapabilities = (recordType, recordId) =>
    get("getApprovalCapabilities", {
        record_type: recordType,
        record_id: recordId,
    });

export const getSalesApprovalList = (params = {}, options = {}) =>
    get("getSalesApprovalList", params, options);

export const getPurchaseApprovalList = (params = {}, options = {}) =>
    get("getPurchaseApprovalList", params, options);

export const getFinanceApprovalList = (params = {}, options = {}) =>
    get("getFinanceApprovalList", params, options);

export const decideApproval = async (
    recordType,
    recordId,
    action,
    rejectionReason = null
) => {
    const response = await apiFetch(`${config.apiUrl}/approveRecord`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            account_id: getAccountId(),
            record_type: recordType,
            record_id: recordId,
            action,
            ...(rejectionReason ? { rejection_reason: rejectionReason } : {}),
        }),
    });
    if (!response.ok) {
        throw new Error(await parseErrorMessage(response, `HTTP ${response.status}`));
    }
    return response.json();
};
